// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.98.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.98.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `


* {
    -webkit-box-sizing: border-box;
       -moz-box-sizing: border-box;
            box-sizing: border-box;
}
*:before,
*:after {
    -webkit-box-sizing: border-box;
       -moz-box-sizing: border-box;
            box-sizing: border-box;
}


#ds24art_wait {
    z-index: 2147483647;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    cursor: wait;
}


#app_cart_added_container {
    position: fixed;
    top: 10px;
    left: 10px;
    right: 10px;
    height: 72px;
    z-index: 2147483644;
    display: block;
    font-size: 16px;
    background: #F0F0F0;
    border: 1px solid #A0A0A0;

    visibility: hidden;
    opacity: 0;
    transition: opacity ease-in 0.3s, visibility ease-in 0.3s;
}

#app_cart_added_container.open {
    opacity: 1;
    visibility: visible;
}



.app_cart_closable {
    opacity: 1;
    transition: opacity ease-in 0.3s;
}

.app_cart_closable.hidden {
    opacity: 0;
}


#app_cart_added_container.ds24_bottom {
    bottom: 10px;
    top: auto;
}

#app_cart_added_container.app_cart_sticky {
    top: 0;
    left: 0;
    right: 0;
}

#app_cart_added_container.app_cart_sticky.ds24_bottom {
    top: auto;
    bottom: 0;
}

#app_cart_added_container > div > div.app_cart_added_close_icon {
    position: absolute;
    top: -3px;
    right: 1px;
    display: block;
    padding: 2px;
    cursor: pointer;
    width: 15px;
    height: 15px;
}

#app_cart_added_container > div > div.app_cart_added_close_icon > img {
    width: 15px;
    height: 15px;
}

.app_cart {
    font-family: "Arial", sans-serif;

}

.app_cart_result_icon {
    width: 65px;
    height: 72px;
    background-color: transparent;
    background-repeat: no-repeat;
    background-position: 10px center;
}

div.app_cart_result_icon.app_cart_result_success {
    background-image: url(https://www.digistore24.com/service/image/msg_success.png);
}

div.app_cart_result_icon.app_cart_result_warning {
    background-image: url(https://www.digistore24.com/service/image/msg_warning.png);
}

div.app_cart_result_icon.app_cart_result_info {
    background-image: url(https://www.digistore24.com/service/image/msg_info.png);
}

div.app_cart_result_icon.app_cart_result_failure {
    background-image: url(https://www.digistore24.com/service/image/msg_error.png);
}

div.app_cart_result_message {
    font-weight: bold;
    padding: 10px;
}

div.app_cart_result_message.app_cart_result_success {
    color: #449529;
}

div.app_cart_result_message.app_cart_result_warning {
    color: #e93;
}

div.app_cart_result_message.app_cart_result_info {
    color: #39d;
}

div.app_cart_result_message.app_cart_result_failure {
    color: #e33;
}

.app_cart_added_buttons {
    white-space: nowrap;
}

#app_cart_added_container.app_cart_sticky .app_cart_added_buttons {
    position: absolute;
    right: 5px;
    top: 5px;
}

#app_cart_added_container.app_cart_sticky.ds24_bottom .app_cart_added_buttons {
    top: unset;
    bottom: 5px;
}

.app_cart_added_buttons > div {
    display: inline-block;
    padding: 10px;
}

#app_cart_added_container > div {
    display: table;
    margin: 0 auto;
}

#app_cart_added_container > div > div {
    display: table-cell;
    vertical-align: middle;
}


div.app_cart_tooltip_container {
    visibility: hidden;
    z-index: 2147483645;
    opacity: 0;
    transition: opacity 0.3s ease-in, visibility 0.3s;
}

.app_cart_tooltip_container.open {
    opacity: 1;
    visibility: visible;
}

.ds24_tooltip_container_window {
    position: fixed;
    z-index: 2147483645;
}

.ds24_tooltip_container_fullscreen {
    display: block;
    width: 100%;
    height: auto;
    position: relative;
}

.ds24_tooltip_container_fullscreen .app_cart_item {
    text-align: center;
}


div.app_cart_tooltip {
    border: 3px solid #CCC;
    background-color: white;
}

div.app_cart_waiting {
    background-image: url('https://www.digistore24.com/service/image/wait.gif');
    background-repeat: no-repeat;
    background-position: center;
    max-width: 500px;
    width: 100%;
    max-height: 200px;
    height: 100%;

}

button.app_cart_button {

    cursor: pointer;
    padding: 10px;
    border-radius: 3px;

    display: inline-block;
    margin: 10px;
    color: #111;
}

button.app_cart_button_primary
{
    background: #f9e2ac;
    background: -moz-linear-gradient(top,    #f3e7d9 0%, #f7c643 50%, #f7c643 51%, #d3a430 100%);
    background: -webkit-linear-gradient(top, #f3e7d9 0%, #f7c643 50%, #f7c643 51%, #d3a430 100%);
    background: -ms-linear-gradient(top,     #f3e7d9 0%, #f7c643 50%, #f7c643 51%, #d3a430 100%);
    background: linear-gradient(to bottom,   #f3e7d9 0%, #f7c643 50%, #f7c643 51%, #d3a430 100%);

    border: 1px solid #888;
    border-radius: 4px;
    box-shadow: 0 0 3px #aaa;
    color: #000;
    font-size: 16px;
    font-weight: normal;
    text-shadow: 0 1px 6px #fff;
    width: auto;
}

button.app_cart_button_primary:hover {
    background: linear-gradient(to bottom, #F3f7e9 0%, #F7d653 50%, #F7d653 51%, #e3b440 100%) repeat scroll 0 0 rgba(0, 0, 0, 0);
    -ms-filter: "progid:DXImageTransform.Microsoft.gradient(startColorStr='#F3F7E9', EndColorStr='#E3B440')";
    color: #000;
    text-shadow: 0 1px 6px #FFFFFF;
    border: 1px solid #444444;
}

button.app_cart_button_secondary
{
    background: rgba(0, 0, 0, 0) linear-gradient(to bottom, #eee 0%, #ddd 50%, #ddd 51%, #ccc 100%) repeat scroll 0 0;
    border: 1px solid #888;
    border-radius: 4px;
    box-shadow: 0 0 3px #aaa;
    color: #000;
    font-size: 16px;
    font-weight: normal;
    text-shadow: 0 1px 6px #fff;
    width: auto;
}

button.app_cart_button_secondary:hover
{
    background: rgba(0, 0, 0, 0) linear-gradient(to bottom, #f7f7f7 0%, #e7e7e7 50%, #e7e7e7 51%, #d7d7d7 100%) repeat scroll 0 0;
    border: 1px solid #888;
    border-radius: 4px;
    box-shadow: 0 0 3px #aaa;
    color: #000;
    font-size: 16px;
    font-weight: normal;
    text-shadow: 0 1px 6px #fff;
    width: auto;
}
button.app_cart_button.disabled {
    background: rgba(0, 0, 0, 0) linear-gradient(to bottom, #f7f7f7 0%, #e7e7e7 50%, #e7e7e7 51%, #d7d7d7 100%) repeat scroll 0 0;
    cursor: not-allowed;
}

div.app_cart_container {
    min-width: 250px;
    min-height: 150px;
    background-color: white;
}

div.app_cart_headiline {
    padding: 5px;
    background-color: #CCC;
    font-weight: bold;
    position: relative;
}

div.app_cart_content {
    padding: 0;
    margin: 0;
    background-color: #FFFFFF;
}

div.app_cart_content.app_cart_without_items {
    padding: 20px 5px;
}

.app_cart_delete {
    cursor: pointer;
}

span.app_cart_delete {
    color: #0d5082;
    font-weight: normal;
    font-size: 80%;
}

div.app_cart_list {
    max-height: 80vh;
    overflow-x: hidden;
    overflow-y: auto;
}


/**
*  Mobile cart
*/


div.app_cart_mobile {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    -webkit-overflow-scrolling: touch;
}

div.app_cart_mobile div.app_cart_container {

    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
}

div.app_cart_mobile div.app_cart_headiline {
    position: absolute;
    top: 0;
    left: 0;
    height: 30px;
    width: 100%;
}

div.app_cart_mobile div.app_cart_content {
    position: absolute;
    top: 30px;
    left: 0;
    width: 100%;
    bottom: 0;
    height: auto;
}

div.app_cart_mobile div.app_cart_content.app_cart_without_items {
    bottom: auto;
    height: auto;
}

div.app_cart_mobile div.app_cart_content.app_cart_with_price.app_cart_without_items {
    padding-top: 40px;
}

div.app_cart_mobile div.app_cart_summary.app_cart_without_items {
    display: none;
}


div.app_cart_mobile div.app_cart_buttons {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 142px;
}



div.app_cart_mobile div.app_cart_summary {
    position: absolute;
    bottom: 152px;
    left: 0;
    right: 0;
    height: 44px;
}

div.app_cart_mobile div.app_cart_list {
    position: absolute;
    top: 30px;
    bottom: 196px;
    left: 0;
    right: 0;
}

div.app_cart_mobile div.app_cart_without_items  {
    position: static;
}



/**
*  Added item message
*/


.app_cart_added_image_container {
    position: relative;
    height: 66px;
    padding: 10px;
}

.app_cart_added_amount_label {
    font-weight: bold;
}

.app_cart_added_amount_sum {
    font-weight: bold;
    color: #b12704;
}

.app_cart_amount_sum{
    padding: 5px 10px 0 0;
    width: 100%;
}

#app_cart_added_container > div > div.app_cart_added_image_container > div.app_cart_added_image {
    border: 1px solid #0A9D0A;
    background-color: white;
    display: -webkit-flex;
    display: flex;
    height: 50px;
    width: auto;
    margin: 0;
}

div.app_cart_added_image img {
    max-height: 50px;
    max-width: 50px;
}

div.app_cart_added_image_selector {
    background-image: url('https://www.digistore24.com/service/image/open_selection.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 8px 8px;
    width: 12px;
    height: 50px;
    margin: 0;
    display: inline-block;
}


.ds24_tooltip_container_window div.app_cart_list {
    display: table;
    padding: 0;
    margin: 0;
}
.ds24_tooltip_container_window div.app_cart_item {
    display: table-row;
    padding: 0;
    margin: 0;
}

.ds24_tooltip_container_window div.app_cart_item > div {
    display: table-cell;
    vertical-align: middle;
    padding: 10px;
    margin: 0;
    border-bottom: 1px solid #CCCCCC;
}

.app_cart_amount {
    font-weight: bold;
    color: #b12704;
    white-space: nowrap;
}

.ds24_tooltip_container_window div.app_cart_item > .app_cart_price
{
    text-align: right;
}

.ds24_tooltip_container_fullscreen div.app_cart_item > .app_cart_quantity
{
    margin-bottom: 20px;
}

div.app_cart_item > .app_cart_name {
    color: #0D5082;
    font-weight: bold;
}

input.app_cart_quantity {
    padding: 1px 0 1px 1px;
    width: 50px;
}

.app_cart_vathint {
    font-size: 90%;
    text-align: right;
    padding-right: 10px;
}

.ds24_tooltip_container_window .app_cart_amount_sum {
    white-space: nowrap;
    width: 100%;
    display: inline-block;
    text-align: right;
}

.ds24_tooltip_container_fullscreen .app_cart_amount_sum,
.ds24_tooltip_container_fullscreen .app_cart_vathint {
    text-align: center;
}

.app_cart_amount_sum > span {
    display: inline-block;
}

.app_cart_amount_sum_label {
    font-weight: bold;
    text-align: right;
}

.app_cart_amount_sum_amount {
    font-weight: bold;
    color: #b12704;
}

.ds24_tooltip_container_window div.app_cart_tooltip {
    display: table;
    margin: 0 auto;
    max-width: 865px;
}


.ds24_tooltip_container_window div.app_cart_item > .app_cart_image {
    width: 10%;
    padding-right: 0;
}
div.app_cart_item > .app_cart_image > img {
    width: 100px;
}

.app_cart_added_summary > span {
    display: inline-block;
}

.ds24_tooltip_container_window div.app_cart_buttons {
    text-align: right;
}
.ds24_tooltip_container_fullscreen div.app_cart_buttons {
    text-align: center;
}


.app_cart_unitprice_label,
.app_cart_quantity_label{
    font-size: 90%;
}

/*Tablet*/
@media screen and (max-width: 800px) {

    #app_cart_added_container {
        height: auto !important;
    }
    #app_cart_added_container > div {
        text-align: center;
    }
    #app_cart_added_container > div > div {
        display: inline-block;
    }
    .app_cart_added_buttons {
        white-space: normal;
    }


    .app_cart_unitprice_label,
    .app_cart_quantity_label {
        display: inline;
    }
}


.app_cart_cart_close_icon {
    position: absolute;
    top: 0;
    right: 0;
    height: 20px;
    width: 20px;
}

.app_cart_cart_close_icon img {
    height: 20px;
    width: 20px;
}

.app_cart_show {
    cursor: pointer;
}

.cart_item_count {
    background-color: #f7c643;
    border-radius: 10px;
    display: inline-block;
    width: 20px;
    height: 20px;
}


.app_cart_on_page .app_cart_cart_close_icon {
    display: none;
}

.ds24_tooltip_container_fullscreen {
    display: block;
    opacity: 0.0;
    transition: opacity ease-in-out 500ms;
}

.ds24_tooltip_container_fullscreen.open {
    display: block;
   opacity: 1.0;
}

@media (max-width: 1375px) {
    #app_cart_added_container.app_cart_sticky .app_cart_added {
        margin: unset;
    }
}

@media (max-width: 1024px) {
    #app_cart_added_container.app_cart_sticky .app_cart_added_with_item .app_cart_added_buttons {
        top: 5px;
        position: relative;
        text-align: right;
        display: block;
    }
}
`, "",{"version":3,"sources":["webpack://./libs/client/src/assets/css/cart.css"],"names":[],"mappings":";;;AAGA;IACI,8BAA8B;OAC3B,2BAA2B;YACtB,sBAAsB;AAClC;AACA;;IAEI,8BAA8B;OAC3B,2BAA2B;YACtB,sBAAsB;AAClC;;;AAGA;IACI,mBAAmB;IACnB,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;;;AAGA;IACI,eAAe;IACf,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,yBAAyB;;IAEzB,kBAAkB;IAClB,UAAU;IACV,yDAAyD;AAC7D;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;;;AAIA;IACI,UAAU;IACV,gCAAgC;AACpC;;AAEA;IACI,UAAU;AACd;;;AAGA;IACI,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,MAAM;IACN,OAAO;IACP,QAAQ;AACZ;;AAEA;IACI,SAAS;IACT,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,cAAc;IACd,YAAY;IACZ,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gCAAgC;;AAEpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,4BAA4B;IAC5B,gCAAgC;AACpC;;AAEA;IACI,gFAAgF;AACpF;;AAEA;IACI,gFAAgF;AACpF;;AAEA;IACI,6EAA6E;AACjF;;AAEA;IACI,8EAA8E;AAClF;;AAEA;IACI,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;;AAGA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,iDAAiD;AACrD;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;;AAGA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,2EAA2E;IAC3E,4BAA4B;IAC5B,2BAA2B;IAC3B,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,YAAY;;AAEhB;;AAEA;;IAEI,eAAe;IACf,aAAa;IACb,kBAAkB;;IAElB,qBAAqB;IACrB,YAAY;IACZ,WAAW;AACf;;AAEA;;IAEI,mBAAmB;IACnB,4FAA4F;IAC5F,4FAA4F;IAC5F,4FAA4F;IAC5F,4FAA4F;;IAE5F,sBAAsB;IACtB,kBAAkB;IAClB,wBAAwB;IACxB,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,6HAA6H;IAC7H,wGAAwG;IACxG,WAAW;IACX,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;;IAEI,iHAAiH;IACjH,sBAAsB;IACtB,kBAAkB;IAClB,wBAAwB;IACxB,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;AACf;;AAEA;;IAEI,6HAA6H;IAC7H,sBAAsB;IACtB,kBAAkB;IAClB,wBAAwB;IACxB,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;AACf;AACA;IACI,6HAA6H;IAC7H,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;;AAGA;;CAEC;;;AAGD;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,iCAAiC;AACrC;;AAEA;;IAEI,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,aAAa;AACjB;;;;AAIA;IACI,kBAAkB;IAClB,aAAa;IACb,OAAO;IACP,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,OAAO;IACP,QAAQ;AACZ;;AAEA;IACI,gBAAgB;AACpB;;;;AAIA;;CAEC;;;AAGD;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,qBAAqB;IACrB,aAAa;IACb,YAAY;IACZ,WAAW;IACX,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,qFAAqF;IACrF,4BAA4B;IAC5B,2BAA2B;IAC3B,wBAAwB;IACxB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,qBAAqB;AACzB;;;AAGA;IACI,cAAc;IACd,UAAU;IACV,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,gBAAgB;AACpB;;;AAGA;IACI,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;;;AAGA;;IAEI,cAAc;AAClB;;AAEA,SAAS;AACT;;IAEI;QACI,uBAAuB;IAC3B;IACA;QACI,kBAAkB;IACtB;IACA;QACI,qBAAqB;IACzB;IACA;QACI,mBAAmB;IACvB;;;IAGA;;QAEI,eAAe;IACnB;AACJ;;;AAGA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,qCAAqC;AACzC;;AAEA;IACI,cAAc;GACf,YAAY;AACf;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,QAAQ;QACR,kBAAkB;QAClB,iBAAiB;QACjB,cAAc;IAClB;AACJ","sourcesContent":["\n\n\n* {\n    -webkit-box-sizing: border-box;\n       -moz-box-sizing: border-box;\n            box-sizing: border-box;\n}\n*:before,\n*:after {\n    -webkit-box-sizing: border-box;\n       -moz-box-sizing: border-box;\n            box-sizing: border-box;\n}\n\n\n#ds24art_wait {\n    z-index: 2147483647;\n    position: fixed;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    cursor: wait;\n}\n\n\n#app_cart_added_container {\n    position: fixed;\n    top: 10px;\n    left: 10px;\n    right: 10px;\n    height: 72px;\n    z-index: 2147483644;\n    display: block;\n    font-size: 16px;\n    background: #F0F0F0;\n    border: 1px solid #A0A0A0;\n\n    visibility: hidden;\n    opacity: 0;\n    transition: opacity ease-in 0.3s, visibility ease-in 0.3s;\n}\n\n#app_cart_added_container.open {\n    opacity: 1;\n    visibility: visible;\n}\n\n\n\n.app_cart_closable {\n    opacity: 1;\n    transition: opacity ease-in 0.3s;\n}\n\n.app_cart_closable.hidden {\n    opacity: 0;\n}\n\n\n#app_cart_added_container.ds24_bottom {\n    bottom: 10px;\n    top: auto;\n}\n\n#app_cart_added_container.app_cart_sticky {\n    top: 0;\n    left: 0;\n    right: 0;\n}\n\n#app_cart_added_container.app_cart_sticky.ds24_bottom {\n    top: auto;\n    bottom: 0;\n}\n\n#app_cart_added_container > div > div.app_cart_added_close_icon {\n    position: absolute;\n    top: -3px;\n    right: 1px;\n    display: block;\n    padding: 2px;\n    cursor: pointer;\n    width: 15px;\n    height: 15px;\n}\n\n#app_cart_added_container > div > div.app_cart_added_close_icon > img {\n    width: 15px;\n    height: 15px;\n}\n\n.app_cart {\n    font-family: \"Arial\", sans-serif;\n\n}\n\n.app_cart_result_icon {\n    width: 65px;\n    height: 72px;\n    background-color: transparent;\n    background-repeat: no-repeat;\n    background-position: 10px center;\n}\n\ndiv.app_cart_result_icon.app_cart_result_success {\n    background-image: url(https://www.digistore24.com/service/image/msg_success.png);\n}\n\ndiv.app_cart_result_icon.app_cart_result_warning {\n    background-image: url(https://www.digistore24.com/service/image/msg_warning.png);\n}\n\ndiv.app_cart_result_icon.app_cart_result_info {\n    background-image: url(https://www.digistore24.com/service/image/msg_info.png);\n}\n\ndiv.app_cart_result_icon.app_cart_result_failure {\n    background-image: url(https://www.digistore24.com/service/image/msg_error.png);\n}\n\ndiv.app_cart_result_message {\n    font-weight: bold;\n    padding: 10px;\n}\n\ndiv.app_cart_result_message.app_cart_result_success {\n    color: #449529;\n}\n\ndiv.app_cart_result_message.app_cart_result_warning {\n    color: #e93;\n}\n\ndiv.app_cart_result_message.app_cart_result_info {\n    color: #39d;\n}\n\ndiv.app_cart_result_message.app_cart_result_failure {\n    color: #e33;\n}\n\n.app_cart_added_buttons {\n    white-space: nowrap;\n}\n\n#app_cart_added_container.app_cart_sticky .app_cart_added_buttons {\n    position: absolute;\n    right: 5px;\n    top: 5px;\n}\n\n#app_cart_added_container.app_cart_sticky.ds24_bottom .app_cart_added_buttons {\n    top: unset;\n    bottom: 5px;\n}\n\n.app_cart_added_buttons > div {\n    display: inline-block;\n    padding: 10px;\n}\n\n#app_cart_added_container > div {\n    display: table;\n    margin: 0 auto;\n}\n\n#app_cart_added_container > div > div {\n    display: table-cell;\n    vertical-align: middle;\n}\n\n\ndiv.app_cart_tooltip_container {\n    visibility: hidden;\n    z-index: 2147483645;\n    opacity: 0;\n    transition: opacity 0.3s ease-in, visibility 0.3s;\n}\n\n.app_cart_tooltip_container.open {\n    opacity: 1;\n    visibility: visible;\n}\n\n.ds24_tooltip_container_window {\n    position: fixed;\n    z-index: 2147483645;\n}\n\n.ds24_tooltip_container_fullscreen {\n    display: block;\n    width: 100%;\n    height: auto;\n    position: relative;\n}\n\n.ds24_tooltip_container_fullscreen .app_cart_item {\n    text-align: center;\n}\n\n\ndiv.app_cart_tooltip {\n    border: 3px solid #CCC;\n    background-color: white;\n}\n\ndiv.app_cart_waiting {\n    background-image: url('https://www.digistore24.com/service/image/wait.gif');\n    background-repeat: no-repeat;\n    background-position: center;\n    max-width: 500px;\n    width: 100%;\n    max-height: 200px;\n    height: 100%;\n\n}\n\nbutton.app_cart_button {\n\n    cursor: pointer;\n    padding: 10px;\n    border-radius: 3px;\n\n    display: inline-block;\n    margin: 10px;\n    color: #111;\n}\n\nbutton.app_cart_button_primary\n{\n    background: #f9e2ac;\n    background: -moz-linear-gradient(top,    #f3e7d9 0%, #f7c643 50%, #f7c643 51%, #d3a430 100%);\n    background: -webkit-linear-gradient(top, #f3e7d9 0%, #f7c643 50%, #f7c643 51%, #d3a430 100%);\n    background: -ms-linear-gradient(top,     #f3e7d9 0%, #f7c643 50%, #f7c643 51%, #d3a430 100%);\n    background: linear-gradient(to bottom,   #f3e7d9 0%, #f7c643 50%, #f7c643 51%, #d3a430 100%);\n\n    border: 1px solid #888;\n    border-radius: 4px;\n    box-shadow: 0 0 3px #aaa;\n    color: #000;\n    font-size: 16px;\n    font-weight: normal;\n    text-shadow: 0 1px 6px #fff;\n    width: auto;\n}\n\nbutton.app_cart_button_primary:hover {\n    background: linear-gradient(to bottom, #F3f7e9 0%, #F7d653 50%, #F7d653 51%, #e3b440 100%) repeat scroll 0 0 rgba(0, 0, 0, 0);\n    -ms-filter: \"progid:DXImageTransform.Microsoft.gradient(startColorStr='#F3F7E9', EndColorStr='#E3B440')\";\n    color: #000;\n    text-shadow: 0 1px 6px #FFFFFF;\n    border: 1px solid #444444;\n}\n\nbutton.app_cart_button_secondary\n{\n    background: rgba(0, 0, 0, 0) linear-gradient(to bottom, #eee 0%, #ddd 50%, #ddd 51%, #ccc 100%) repeat scroll 0 0;\n    border: 1px solid #888;\n    border-radius: 4px;\n    box-shadow: 0 0 3px #aaa;\n    color: #000;\n    font-size: 16px;\n    font-weight: normal;\n    text-shadow: 0 1px 6px #fff;\n    width: auto;\n}\n\nbutton.app_cart_button_secondary:hover\n{\n    background: rgba(0, 0, 0, 0) linear-gradient(to bottom, #f7f7f7 0%, #e7e7e7 50%, #e7e7e7 51%, #d7d7d7 100%) repeat scroll 0 0;\n    border: 1px solid #888;\n    border-radius: 4px;\n    box-shadow: 0 0 3px #aaa;\n    color: #000;\n    font-size: 16px;\n    font-weight: normal;\n    text-shadow: 0 1px 6px #fff;\n    width: auto;\n}\nbutton.app_cart_button.disabled {\n    background: rgba(0, 0, 0, 0) linear-gradient(to bottom, #f7f7f7 0%, #e7e7e7 50%, #e7e7e7 51%, #d7d7d7 100%) repeat scroll 0 0;\n    cursor: not-allowed;\n}\n\ndiv.app_cart_container {\n    min-width: 250px;\n    min-height: 150px;\n    background-color: white;\n}\n\ndiv.app_cart_headiline {\n    padding: 5px;\n    background-color: #CCC;\n    font-weight: bold;\n    position: relative;\n}\n\ndiv.app_cart_content {\n    padding: 0;\n    margin: 0;\n    background-color: #FFFFFF;\n}\n\ndiv.app_cart_content.app_cart_without_items {\n    padding: 20px 5px;\n}\n\n.app_cart_delete {\n    cursor: pointer;\n}\n\nspan.app_cart_delete {\n    color: #0d5082;\n    font-weight: normal;\n    font-size: 80%;\n}\n\ndiv.app_cart_list {\n    max-height: 80vh;\n    overflow-x: hidden;\n    overflow-y: auto;\n}\n\n\n/**\n*  Mobile cart\n*/\n\n\ndiv.app_cart_mobile {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    width: 100%;\n    height: 100%;\n    -webkit-overflow-scrolling: touch;\n}\n\ndiv.app_cart_mobile div.app_cart_container {\n\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    width: 100%;\n    height: 100%;\n}\n\ndiv.app_cart_mobile div.app_cart_headiline {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 30px;\n    width: 100%;\n}\n\ndiv.app_cart_mobile div.app_cart_content {\n    position: absolute;\n    top: 30px;\n    left: 0;\n    width: 100%;\n    bottom: 0;\n    height: auto;\n}\n\ndiv.app_cart_mobile div.app_cart_content.app_cart_without_items {\n    bottom: auto;\n    height: auto;\n}\n\ndiv.app_cart_mobile div.app_cart_content.app_cart_with_price.app_cart_without_items {\n    padding-top: 40px;\n}\n\ndiv.app_cart_mobile div.app_cart_summary.app_cart_without_items {\n    display: none;\n}\n\n\ndiv.app_cart_mobile div.app_cart_buttons {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 142px;\n}\n\n\n\ndiv.app_cart_mobile div.app_cart_summary {\n    position: absolute;\n    bottom: 152px;\n    left: 0;\n    right: 0;\n    height: 44px;\n}\n\ndiv.app_cart_mobile div.app_cart_list {\n    position: absolute;\n    top: 30px;\n    bottom: 196px;\n    left: 0;\n    right: 0;\n}\n\ndiv.app_cart_mobile div.app_cart_without_items  {\n    position: static;\n}\n\n\n\n/**\n*  Added item message\n*/\n\n\n.app_cart_added_image_container {\n    position: relative;\n    height: 66px;\n    padding: 10px;\n}\n\n.app_cart_added_amount_label {\n    font-weight: bold;\n}\n\n.app_cart_added_amount_sum {\n    font-weight: bold;\n    color: #b12704;\n}\n\n.app_cart_amount_sum{\n    padding: 5px 10px 0 0;\n    width: 100%;\n}\n\n#app_cart_added_container > div > div.app_cart_added_image_container > div.app_cart_added_image {\n    border: 1px solid #0A9D0A;\n    background-color: white;\n    display: -webkit-flex;\n    display: flex;\n    height: 50px;\n    width: auto;\n    margin: 0;\n}\n\ndiv.app_cart_added_image img {\n    max-height: 50px;\n    max-width: 50px;\n}\n\ndiv.app_cart_added_image_selector {\n    background-image: url('https://www.digistore24.com/service/image/open_selection.png');\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 8px 8px;\n    width: 12px;\n    height: 50px;\n    margin: 0;\n    display: inline-block;\n}\n\n\n.ds24_tooltip_container_window div.app_cart_list {\n    display: table;\n    padding: 0;\n    margin: 0;\n}\n.ds24_tooltip_container_window div.app_cart_item {\n    display: table-row;\n    padding: 0;\n    margin: 0;\n}\n\n.ds24_tooltip_container_window div.app_cart_item > div {\n    display: table-cell;\n    vertical-align: middle;\n    padding: 10px;\n    margin: 0;\n    border-bottom: 1px solid #CCCCCC;\n}\n\n.app_cart_amount {\n    font-weight: bold;\n    color: #b12704;\n    white-space: nowrap;\n}\n\n.ds24_tooltip_container_window div.app_cart_item > .app_cart_price\n{\n    text-align: right;\n}\n\n.ds24_tooltip_container_fullscreen div.app_cart_item > .app_cart_quantity\n{\n    margin-bottom: 20px;\n}\n\ndiv.app_cart_item > .app_cart_name {\n    color: #0D5082;\n    font-weight: bold;\n}\n\ninput.app_cart_quantity {\n    padding: 1px 0 1px 1px;\n    width: 50px;\n}\n\n.app_cart_vathint {\n    font-size: 90%;\n    text-align: right;\n    padding-right: 10px;\n}\n\n.ds24_tooltip_container_window .app_cart_amount_sum {\n    white-space: nowrap;\n    width: 100%;\n    display: inline-block;\n    text-align: right;\n}\n\n.ds24_tooltip_container_fullscreen .app_cart_amount_sum,\n.ds24_tooltip_container_fullscreen .app_cart_vathint {\n    text-align: center;\n}\n\n.app_cart_amount_sum > span {\n    display: inline-block;\n}\n\n.app_cart_amount_sum_label {\n    font-weight: bold;\n    text-align: right;\n}\n\n.app_cart_amount_sum_amount {\n    font-weight: bold;\n    color: #b12704;\n}\n\n.ds24_tooltip_container_window div.app_cart_tooltip {\n    display: table;\n    margin: 0 auto;\n    max-width: 865px;\n}\n\n\n.ds24_tooltip_container_window div.app_cart_item > .app_cart_image {\n    width: 10%;\n    padding-right: 0;\n}\ndiv.app_cart_item > .app_cart_image > img {\n    width: 100px;\n}\n\n.app_cart_added_summary > span {\n    display: inline-block;\n}\n\n.ds24_tooltip_container_window div.app_cart_buttons {\n    text-align: right;\n}\n.ds24_tooltip_container_fullscreen div.app_cart_buttons {\n    text-align: center;\n}\n\n\n.app_cart_unitprice_label,\n.app_cart_quantity_label{\n    font-size: 90%;\n}\n\n/*Tablet*/\n@media screen and (max-width: 800px) {\n\n    #app_cart_added_container {\n        height: auto !important;\n    }\n    #app_cart_added_container > div {\n        text-align: center;\n    }\n    #app_cart_added_container > div > div {\n        display: inline-block;\n    }\n    .app_cart_added_buttons {\n        white-space: normal;\n    }\n\n\n    .app_cart_unitprice_label,\n    .app_cart_quantity_label {\n        display: inline;\n    }\n}\n\n\n.app_cart_cart_close_icon {\n    position: absolute;\n    top: 0;\n    right: 0;\n    height: 20px;\n    width: 20px;\n}\n\n.app_cart_cart_close_icon img {\n    height: 20px;\n    width: 20px;\n}\n\n.app_cart_show {\n    cursor: pointer;\n}\n\n.cart_item_count {\n    background-color: #f7c643;\n    border-radius: 10px;\n    display: inline-block;\n    width: 20px;\n    height: 20px;\n}\n\n\n.app_cart_on_page .app_cart_cart_close_icon {\n    display: none;\n}\n\n.ds24_tooltip_container_fullscreen {\n    display: block;\n    opacity: 0.0;\n    transition: opacity ease-in-out 500ms;\n}\n\n.ds24_tooltip_container_fullscreen.open {\n    display: block;\n   opacity: 1.0;\n}\n\n@media (max-width: 1375px) {\n    #app_cart_added_container.app_cart_sticky .app_cart_added {\n        margin: unset;\n    }\n}\n\n@media (max-width: 1024px) {\n    #app_cart_added_container.app_cart_sticky .app_cart_added_with_item .app_cart_added_buttons {\n        top: 5px;\n        position: relative;\n        text-align: right;\n        display: block;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
